import { Check } from "@mui/icons-material";
import React from "react";

interface FcmListItemProps {
  text: string;
  /** Accepted for API compatibility; not currently used in rendering. */
  reverse?: boolean;
}

export const FcmListItem = ({ text }: FcmListItemProps) => {
  return (
    <li className="fcmListItem mb-2r">
      <Check
        sx={{
          color: "var(--primary-color)",
          fontSize: "3.2rem",
        }}
      />
      <span>{text}</span>
    </li>
  );
};
